import React from 'react';
import { CnButton } from '@cainiaofe/cn-ui';
import { CnStatisticActionProps } from './types';
import CnStatisticBaseAction from './base';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticAction({ children, ...rest }: CnStatisticActionProps) {
  return (
    <CnStatisticBaseAction CnButton={CnButton} {...rest}>
      {children}
    </CnStatisticBaseAction>
  );
}

export { CnStatisticAction };
export type { CnStatisticActionProps };
